import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const Typography = ({ children, as = 'p', variant = 'base', className = '', ...props }) => {
  const variantMap = useMemo(
    () => ({
      xSmall: 'text-f7 fw-normal line-height-light letter-spacing-light',
      xSmallSemi: 'text-f7 fw-bold line-height-light letter-spacing-light',
      xSmallBold: 'text-f7 fw-bolder line-height-light letter-spacing-light',
      small: 'text-f6 fw-normal line-height-light letter-spacing-light',
      smallSemi: 'text-f6 fw-bold line-height-light letter-spacing-light',
      smallBold: 'text-f6 fw-bolder line-height-light letter-spacing-light',
      base: 'text-f5 fw-normal line-height-normal letter-spacing-normal',
      baseSemi: 'text-f5 fw-bold line-height-normal letter-spacing-normal',
      baseBold: 'text-f5 fw-bolder line-height-normal letter-spacing-normal',
      large: 'text-f4 fw-normal line-height-large letter-spacing-normal',
      largeSemi: 'text-f4 fw-bold line-height-large letter-spacing-normal',
      largeBold: 'text-f4 fw-bolder line-height-large letter-spacing-normal',
      xLarge: 'text-f3 fw-normal line-height-large letter-spacing-normal',
      xLargeSemi: 'text-f3 fw-bold line-height-large letter-spacing-normal',
      xLargeBold: 'text-f3 fw-bolder line-height-large letter-spacing-normal',
    }),
    []
  );

  const Element = as;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Element {...props} className={`${variantMap[variant]} ${className ?? ''}`}>
      {children}
    </Element>
  );
};

Typography.propTypes = {
  variant: PropTypes.string,
  as: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  className: PropTypes.string,
};
